import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const DeleteListConfirmModal = ({ open, onClose, onConfirm, list, loading }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('confirm_delete') || 'Confirmar eliminación'}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('confirm_delete_list_message', { name: list?.name }) || `¿Estás seguro de que deseas eliminar la lista "${list?.name}"? Esta acción no se puede deshacer.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          {t('cancel')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteListConfirmModal;

